<template>
  <CCard class="dataTable py-5 mt-3">
    <CRow class="pt-5 pb-4">
      <CCol sm="12" class="d-flex flex-column">
        <div>
          <h2 class="titlePage font-weight-normal text-capitalize mb-1">{{ $t('request.title.requests') }}</h2>
          <CAlert :color="this.$route.params.status" closeButton v-if="this.$route.params.message" :show.sync="currentAlertCounter">
            <center>
              <strong>{{ this.$route.params.message }}</strong>
            </center>
            <CProgress :max="10" :value="currentAlertCounter" height="3px" :color="this.$route.params.status" animate />
          </CAlert>
        </div>
      </CCol>
    </CRow>
    <CCardHeader class="dataTable__header d-flex justify-content-between px-0 pb-5">
      <div class="dataTable__countContants">
        <h3 class="mt-3 font-weight-normal d-flex align-items-sm-center text-warning">
          <CIcon class="mr-3" name="pending" size="custom-size" :height="25" viewBox="0 0 32 32" />
          <span class="font-count">{{ totalRecords || 0 }}</span>
          <span class="font-sm text-uppercase ml-2">{{ $t('request.text.requestsPending') }}</span>
        </h3>
      </div>
      <div class="dataTable__search">
        <CInput
          type="search"
          :placeholder="$t('request.placeholder.search')"
          addInputClasses="pl-5"
          class="iconSearchPlaceholder pb-0"
          v-model="tableFilterValue"
        ></CInput>
      </div>
      <div class="dataTable__buttonLink">
        <!-- <router-link class="btn btn-primary px-4 py-3 font-weight-bold" tag="button" :to="{ name: 'users-invite' }">{{
          $t('settings.profile.organization.user.link.addUser')
        }}</router-link> -->
      </div>
    </CCardHeader>

    <transition name="fade">
      <MenssageAlert :messages="messages" />
    </transition>

    <HeaderActions
      :show="{
        checkItems: true,
        manage: false,
        filterBy: false,
      }"
      :multiSelect="true"
      :aproveRefuse="showApproveRefuse"
      @aproved="evento"
      @refused="evento"
      @checkAll="checkAll"
      @filterBy="chooseFilterBy"
    />

    <CCardBody class="dataTable__body p-0">
      <CDataTable
        :items="registers"
        :fields="headers"
        :table-filter="{ external: true, lazy: true }"
        :table-filter-value.sync="tableFilterValue"
        items-per-page-select
        @row-clicked="selectItem"
        :items-per-page.sync="itemsPerPage"
        @pagination-change="paginationChange"
        :active-page="1"
        hover
        :loading="loading"
      >
        <template #loading>
          <div class="d-flex justify-content-center align-items-center dataTable__loading">
            <CSpinner class="my-3" color="primary" />
          </div>
        </template>

        <template #select="{ item }">
          <td @click.stop>
            <CInputCheckbox class="text-center checkboxTable" :checked="item._selected" @update:checked="() => check(item)" custom />
          </td>
        </template>

        <template #status="{ item }">
          <td style="vertical-align: bottom">
            <CIcon
              class="mr-1"
              :class="item.status == 0 ? 'text-warning' : 'text-success'"
              :name="item.status == 0 ? 'pending' : 'checkCircle'"
              size="custom-size"
              :height="25"
              viewBox="0 0 32 32"
            />
            <span class="text-capitalize"> {{ statusType(item.status) }}</span>
          </td>
        </template>

        <template #threatedBy="{ item }">
          <td>
            {{ item.threatedBy ? item.threatedBy : '-' }}
          </td>
        </template>

        <template #requestDate="{ item }">
          <td>
            {{ formatDate(item.requestDate) }}
          </td>
        </template>

        <template #dateHandled="{ item }">
          <td>
            {{ item.dateHandled ? formatDate(item.dateHandled) : '-' }}
          </td>
        </template>
      </CDataTable>
    </CCardBody>

    <CPagination
      v-show="pages > 0"
      :pages="pages"
      class="dataTable__pagination"
      :class="{ [$style.blockClick]: this.loading }"
      :doubleArrows="false"
      :active-page.sync="activePage"
      ref="pagination"
    >
      <template slot="previous-button">
        <span class="pagination__button p-2">
          <i class="icon fas fa-angle-left font-weight-light fa-2x text-gray-500"></i>
        </span>
      </template>

      <template slot="next-button">
        <span class="pagination__button p-2">
          <i class="icon fas fa-angle-right font-weight-light fa-2x text-gray-500"></i>
        </span>
      </template>
    </CPagination>

    <div v-if="pagination.totalPages > 1" class="page-item d-flex justify-content-center paginationDetail text-gray-600">
      {{ pagination.currentPage }} of {{ pagination.totalPages }}
    </div>
  </CCard>
</template>

<script>
const headerLabel = [
  {
    key: 'select',
    label: '',
    _classes: 'hidde',
    _style: 'width:50px',
  },
  { key: 'status', label: 'STATUS' },
  { key: 'account', label: 'ACCOUTN' },
  { key: 'orderType', label: 'ORDER TYPE' },
  { key: 'requestDate', label: 'REQUEST DATE' },
  { key: 'threatedBy', label: 'THREATED BY' },
  { key: 'dateHandled', label: 'DATE HANDLED' },
]

const statusTypes = {
  0: 'UNRESOLVED',
  1: 'RESOLVED',
}

const mockList = [
  {
    requestId: 1,
    status: 0,
    account: 'Vodafone',
    orderType: 'Access request',
    requestDate: new Date().toISOString(),
    threatedBy: null,
    dateHandled: null,
  },
  {
    requestId: 2,
    status: 0,
    account: 'Meo Lisboa',
    orderType: 'Campaign Submission',
    requestDate: new Date().toISOString(),
    threatedBy: null,
    dateHandled: null,
  },
  {
    requestId: 3,
    status: 1,
    account: 'Vodafone',
    orderType: 'Access request',
    requestDate: new Date().toISOString(),
    threatedBy: 'User Mock',
    dateHandled: new Date().toISOString(),
  },
  {
    requestId: 4,
    status: 1,
    account: 'Vodafone',
    orderType: 'New Domain',
    requestDate: new Date().toISOString(),
    threatedBy: 'User Mock',
    dateHandled: new Date().toISOString(),
  },
]

import HeaderActions from '@/components/table/HeaderActions'
import MenssageAlert from '@/components/MenssageAlert'
import { dateTimeFormatString } from '../../../utils/dateUtil'

import services from '@/services'

export default {
  name: 'Request',
  components: {
    MenssageAlert,
    HeaderActions,
  },
  data() {
    return {
      tableFilterValue: null,
      loading: false,
      itemsPerPage: 10,
      pages: 0,
      headers: [],
      totalPendings: 0,
      totalRecords: 0,
      itemsListSelected: [],
      activePage: 1,
      messages: [],
      organizationId: this.$store.state.auth.organizationId,
      userId: this.$store.state.auth.user.id,
      currentAlertCounter: 5,
      pagination: [],
    }
  },

  created() {
    this.getData({
      Page: this.activePage,
      Count: this.itemsPerPage,
    })
  },

  watch: {
    reloadParams() {
      this.onTableChange()
    },
  },

  computed: {
    registers() {
      return this.loadedItems.map((request, index) => {
        return {
          ...request,
          _selected: this.itemsListSelected.includes(index),
          _classes: [request._classes, request._selected || this.itemsListSelected.includes(index) ? 'table-selected' : ''],
        }
      })
    },

    showApproveRefuse() {
      if (this.itemsListSelected.length > 0) {
        return !this.loadedItems.filter((elm) => elm._selected).filter((elm) => elm.status == 1).length > 0
      }
      return false
    },

    itemsPending() {
      return 0
      // return this.loadedItems.find(item => item.statusIdto == 1)
    },

    reloadParams() {
      return [this.activePage, this.itemsPerPage, this.tableFilterValue]
    },

    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage
      const totalPage = this.activePage * 10 > this.totalRecords ? this.totalRecords : this.activePage * 10
      return `${first} - ${totalPage}  of ${this.totalRecords}`
    },
  },

  methods: {
    evento() {},

    formatDate(date) {
      return date ? dateTimeFormatString(date) : ''
    },

    headerHandle() {
      return headerLabel
    },

    mountItemsTable(arr) {
      return arr.reduce((acc, cur, index) => {
        acc.push({
          ...cur,
          _id: index,
          _toggled: false,
          index: index,
          _classes: [cur._selected ? 'table-selected' : null],
        })
        return acc
      }, [])
    },

    getData(data) {
      this.loading = true

      // ! AREA MOCK
      this.pages = Math.ceil(mockList.length / 10)
      this.totalRecords = mockList.filter((x) => x.status == 0).length
      this.activePage = 1
      this.headers = this.headerHandle()
      this.loadedItems = this.mountItemsTable(mockList)
      this.pagination = {
        currentCount: 10,
        currentPage: 1,
        nextPage: 1,
        previousPage: 0,
        totalPages: 1,
        totalRecords: 5,
      }

      this.loading = false
      // ! FIM AREA MOCK

      // services
      //   .getUsers(data.Page, data.Count, this.organizationId)
      //   .then(invites => {
      //     this.pages = Math.ceil(invites.data.data.pageOptionsResponse.totalRecords / 10)
      //     this.totalInvites = invites.data.data.items.length
      //     this.totalRecords = invites.data.data.pageOptionsResponse.totalRecords
      //     this.activePage = invites.data.data.pageOptionsResponse.currentPage
      //     this.headers = this.headerHandle()
      //     this.loadedItems = this.mountItemsTable(invites.data.data.items)
      //     this.pagination = invites.data.data.pageOptionsResponse
      //   })
      //   .catch(() => {
      //     this.loadedItems = []
      //   })
      //   .finally(() => {
      //     this.loading = false
      //   })
    },

    onTableChange() {
      this.loading = true
      this.getData({
        Page: this.activePage,
        Count: this.itemsPerPage,
      })
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    check(item) {
      const val = Boolean(this.loadedItems[item.index]._selected)
      this.$set(this.loadedItems[item.index], '_selected', !val)
      this.checkedItem(item._id)
    },

    checkAll(state) {
      this.loadedItems.forEach((item) => {
        this.$set(this.loadedItems[item.index], '_selected', state)
      })
      this.checkedAllitems(state)
    },

    checkedAllitems(state) {
      if (!state) {
        this.itemsListSelected = []
        return
      }
      this.itemsListSelected = this.loadedItems.reduce((acc, cur) => {
        acc.push(cur._id)
        return acc
      }, [])
    },

    checkedItem(id = '') {
      if (this.itemsListSelected.includes(id)) {
        this.itemsListSelected = this.itemsListSelected.filter((item) => item !== id)
        return
      }

      this.itemsListSelected.push(id)
    },

    statusType(status) {
      return statusTypes[status]
    },

    chooseFilterBy(item) {
      this.SenderStatusId = null
      this.OrganizationStatusId = null

      if (item === 'all') {
        return
      }

      this[item.column] = item.value
    },

    getOrganizationUsers() {
      this.$store.dispatch('senders/organizationUsers', this.$store.state.auth.organizationId)
    },

    selectItem(row) {
      if (row.inviteId) {
        this.$router.push({ name: 'users-edit-invite', params: { inviteId: row.inviteId } })
        return
      }
      if (row.userId) {
        this.$router.push({ name: 'users-edit-user-organization', params: { userId: row.userId, organizationUserId: row.organizationUserId } })
        return
      }
    },
  },
}
</script>
<style scoped lang="scss">
.font-count {
  font-size: $font-size-xl;
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
